<template>
  <div class="question">
    <quesList :list="list" :type="6"></quesList>
    <!-- <v-Loading></v-Loading> -->
  </div>
</template>

<script>
import quesList from './quesList'
// import vLoading from './vloading'
export default {
  name: 'question',
  data () {
    return {
      list :[]
    }
  },
  mounted() {
    document.title = "常见问题"
     const formData = new FormData()
      formData.append('h5Type', 6)
      // utils.showLoading()
     this.$http({
        method: 'post',
        url: '/api/mine/html5List',
        data: formData
     }).then((res)=>{

        // utils.hideLoading()
        if(res.data.status === 200){
        this.list = res.data.data.appHtml5
        }else{
        alert(res.data.msg)
        }
      })
  },
  components: {
    quesList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/question.vue